'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function noop() {}

function create() {
  var chunkQueue = [];
  var drainer = null;
  var _drainerResolver = noop;
  var ended = false;
  var outWait = null;
  var _outWaitResolver = noop;

  var makeDrainer = function makeDrainer() {
    if (!drainer) {
      drainer = new Promise(function (resolve) {
        _drainerResolver = function drainerResolver() {
          drainer = null;
          _drainerResolver = noop;
          resolve();
        };
      });
    }

    return drainer;
  };

  var writer = {
    write: function write(chunk) {
      chunkQueue.push(chunk);
      var drainer = makeDrainer();

      _outWaitResolver();

      return drainer;
    },
    end: function end() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var drainer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ended = true;
                drainer = makeDrainer();

                _outWaitResolver();

                return _context.abrupt("return", drainer);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
  var iterator = {
    next: function next() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var chunk;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                chunk = chunkQueue.shift();

                if (!chunk) {
                  _context2.next = 4;
                  break;
                }

                if (chunkQueue.length === 0) {
                  _drainerResolver();
                }

                return _context2.abrupt("return", {
                  done: false,
                  value: chunk
                });

              case 4:
                if (!ended) {
                  _context2.next = 7;
                  break;
                }

                _drainerResolver();

                return _context2.abrupt("return", {
                  done: true,
                  value: undefined
                });

              case 7:
                if (!outWait) {
                  outWait = new Promise(function (resolve) {
                    _outWaitResolver = function outWaitResolver() {
                      outWait = null;
                      _outWaitResolver = noop;
                      return resolve(iterator.next());
                    };
                  });
                }

                return _context2.abrupt("return", outWait);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
  return {
    writer: writer,
    iterator: iterator
  };
}

exports.create = create;